'use strict'
/**
 * This same control dialog is used for single control, bulk control and group control.
 * If the options object of the model contains a group property or bulkAction property the
 * saving of the models is threated differently.
 */
var _ = require('lodash')
var App = require('app')

var EditNewController = require('src/components/edit_new-controller.js')

var RoutineComposer = require('src/components/routine-composer')
var DialogModel = require('src/common/dialog-model.js')
var Helpers = require('src/common/helpers')
let DeviceTypes = require('src/common/app-constants').deviceTypes

/* Views */
var View = require('./view.js')

var DeviceControl = function (options) {
  var Controller = EditNewController.extend({
    initialize: function (options) {
      var self = this
      this.region = options.region

      var clients = App.globalChannel.request('client:entities:cached')
      var device = options.device
      var devices = options.collection

      var group = options.group

      if (group) {
        self.deviceType = group.get('type')
        var client = clients.get(group.get('client'))
      } else if (device) {
        self.deviceType = device.get('type')
        var client = clients.get(device.get('client'))
      }




      // in case of a bulkAction get the client and device type
      if (options.bulkAction) {
        var client = clients.get(App.session.user.get('client'))

        // if the bulk collection is of one devicetype, set the devicetype
        var deviceTypes = _.uniq(_.map(devices.where({_bulk: true}), 'attributes.type'))
        if (deviceTypes.length === 1) self.deviceType = deviceTypes[0]

      }

      self.deviceDefinition = DeviceTypes.find(({id}) => id === self.deviceType)


      self.device = device
      self.client = client
      self.routineComposers = []

      // Dialog Model
      //
      var dialogModel = new DialogModel({
        title: 'Control device',
        automaticTitle: false, // detects wheter the model is new or edit

        buttons: {
          left: [
            { label: 'save preset', icon: false, slug: 'save-preset', action: 'dialog:save-preset', roles: ['super', 'admin'] }
          ],
          right: [
            { label: 'cancel', slug: 'cancel', action: 'dialog:close', roles: ['super', 'admin'] },
            { label: 'save', primary: true, slug: 'save', action: 'dialog:submit', roles: ['super', 'admin'] }
          ]
        },
        tabs: [
          { label: 'Control', slug: 'basic', elementId: 'tab-control', roles: [] },
          { label: 'Firmware', slug: 'properties', elementId: 'tab-firmware', roles: ['super'] }
        ]
      })


      if (group) dialogModel.set({title: 'Control devices'})

      // control buttons
      this.controlButtons = {
        'rtm_dali_x':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_dali_4':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_dali_10':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_dali_18':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_zsc_v1':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_zsc_100':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_zsc_100E':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_zsc_120':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_zsc_f':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_zsc_r':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_zsc_s':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_zsc':[
          {
            'label':'Get status',
            'command':'identification.set.status',
            'value':1
          }
        ],
        'rtm_rhm':[
          {
            'label':'Fetch register',
            'command':'modbus_registers.get.register',
            'value':1
          },
          {
            'label':'Livelogs (water tap)',
            'command':'modbus_registers.get.livelog_tap_water',
            'value':1
          },
          {
            'label':'Livelogs (heat)',
            'command':'modbus_registers.get.livelog_heating',
            'value':1
          },
          {
            'label':'Livelogs (heat/cool)',
            'command':'modbus_registers.get.livelog_heating_cooling',
            'value':1
          }
        ],
        'rtm_rhm_mqtt':[
          {
            'label':'Fetch register',
            'command':'modbus_registers.get.register',
            'value':1
          },
          {
            'label':'Livelogs (water tap)',
            'command':'modbus_registers.get.livelog_tap_water',
            'value':1
          },
          {
            'label':'Livelogs (heat)',
            'command':'modbus_registers.get.livelog_heating',
            'value':1
          },
          {
            'label':'Livelogs (heat/cool)',
            'command':'modbus_registers.get.livelog_heating_cooling',
            'value':1
          }
        ],
        'rtm_dyn':[
          {
            'label':'Refresh relay status',
            'command':'dyna.get.refresh_relay_status',
            'value':1
          },
          {
            'label':'Device lost',
            'command':'identification.get.lost',
            'value':1
          }
        ],
        'rtm_dyn_b':[
          {
            'label':'Refresh relay status',
            'command':'dyna_b.get.refresh_relay_status',
            'value':1
          },
          {
            'label':'Device lost',
            'command':'identification.get.lost',
            'value':1
          }
        ]
      }

      //
      this.view = this.getView(dialogModel, device, devices, client, self.deviceType)

      this.listenTo(this.view, 'render', function (view) {
        self.bodyRegion(device, devices, client, self.deviceType)
      })

      this.listenTo(this.view, 'dialog:save-preset', this.onSavePreset)
      this.listenTo(this.view, 'dialog:submit', this.formSubmit)

      this.region.show(this.view)
    },
    /**
     *
     */
    parseRoutines: function (view) {
      var routines = []

      var composerTypes = [];
      var multiComposerTypes = [];

      if (this.routineComposers.length > 0) {
        composerTypes = this.routineComposers.map(composer => composer.options.type);
        multiComposerTypes = [...new Set(composerTypes.filter((v, i) => composerTypes.indexOf(v) !== i))];
      }



      for (var i = 0; i < this.routineComposers.length; i++) {
        var composer = this.routineComposers[i]
        var composerType = composer.options.type;
        var composerRoutines = composer.getRoutine()

        // if there are multiple composers keep track of the index, dali-x uses this to address channels
        if (multiComposerTypes.length > 0 && multiComposerTypes.indexOf(composerType > -1)) {
          // add channel to the routines
             composerRoutines = composerRoutines.map((routine) => {
                return Object.assign(routine, {channel:composer.options.channel})
              })
        }

        routines = routines.concat(composerRoutines)
      }

      return routines
    },
    formPreSave: function (model, data) {
      let self = this
      let groupModel = this.options.group
      let isGroupControl = (groupModel)

      let routines = this.parseRoutines()
      let payload = {}
      payload.defaultSchedule = routines

      routines.forEach (function(element) {
        if (element.time == 126000) {
          element.time = 125999
        }
      })

      // handle differently based on if this is a device edit or a device group edit
      if (isGroupControl) {
        App.dialog.confirm({
          message: 'Are you sure you want to control all the devices in the group?',
          callback: function (confirmed) {
            if (confirmed) {
              groupModel.updateDevices(payload, {
                success: function () {
                  self.region.empty()
                },
                error: function () {
                  App.dialog.alert('Something went wrong while controlling the devices')
                }
              })
            }
          }
        })

        // prevent the normal execution
        return false
      } else {
        return payload
      }
    },
    // prepare the bulk data to be saved
    formBulkPreSave: function (model, collection, data) {
      let routines = this.parseRoutines()
      let payload = {}
      payload.defaultSchedule = routines

      return payload
    },
    onUpdateFirmware: function(view,data) {
      let self = this;

      let performUpdate = () => {

        const regex = /^(\d+\.)(\d+\.)(\d+)$/gm;

        let value = '';


        if (data.type == 'ota') {
          if (data.version == '' || !regex.test(data.version)) {
            App.dialog.alert('The given version is not a valid format')
            return
          }

          let newVersionExpl = data.version.split(".");

          // do no version checks when performing bulk
          if (!self.options.bulkAction) {
            let currentVersion = self.device.get('firmwareVersion') || ""
            let currentVersionExpl = currentVersion.split(".")

             // if there is a previous version, check if this is a valid version change
             if (currentVersionExpl.length == 3) {

                let curMod = currentVersionExpl[2] % 2 == 0
                let newMod = newVersionExpl[2] % 2 == 0
                if (curMod == newMod) {
                  App.dialog.alert('There is an issue with this specific version number. Determine if the "patch" digit has at least one position difference from the current version.');
                  return;
                }
             }
          }

           //
           newVersionExpl = newVersionExpl.map(v => {
             return Helpers.dec2hex(parseInt(v))
           })

           value = "00" + newVersionExpl.join("");
        }

         // convert version to hex
         self.onSendCommand({
          command: data.command,
          value: value
        });
      }

      //
      if (this.options.bulkAction) {
        App.dialog.confirm({
          message: 'Important! You\'re about to perform a firmware update on multiple devices. Only continue if you\'re sure that these devices accept the new version.',
          callback: function (confirmed) {
            if (confirmed) {
              performUpdate();
            }
          }
        })

      } else {
        performUpdate();
      }



    },
    /* Regions --------------------------------------------------------------- */
    bodyRegion: function (device, devices, client, deviceType) {
      var self = this
      this.wrapperView = this.getWrapperView(deviceType)

      this.listenTo(this.wrapperView, 'render', function (view) {
        // console.log(devices)
         self.controlRegion(device, devices, client, self.deviceType)
      })

      this.listenTo(this.wrapperView, 'control:send-command', this.onSendCommand)
      this.listenTo(this.wrapperView, 'control:update-firmware', this.onUpdateFirmware)

      self.view.showChildView('bodyRegion', self.wrapperView )

    },

    controlRegion: function (device, devices, client, deviceType) {
      var self = this

      var bodyView = self.getBodyView(device, devices, client, deviceType)


      // dynamically add 10 regions when this is a dali-x device
      if (deviceType == 'rtm_dali_x' || deviceType == 'rtm_dali_10') {
        for (let i = 0; i < 10; i++) {
          bodyView.addRegion("routineRegion_dali_"+(i+1), '.routine__region-dali_'+(i+1));
        }
      }

      this.listenTo(bodyView, 'render', function (view) {
        //
        var routine = []
        if (device) routine = device.get('defaultSchedule')

        self.routineRegion(bodyView, routine)
      })
      this.listenTo(bodyView, 'control:load-preset', this.onLoadPreset)
      this.listenTo(bodyView, 'control:send-command', this.onSendCommand)

      self.wrapperView.showChildView('controlRegion', bodyView)
    },
    /**
     * Region which handles the composers
     */
    routineRegion: function (view, commands) {
      var self = this
      var types = false

      var routineByType = Helpers.convertCommandsToRoutineNew(commands)

      // determine which routine types are needed by the device
      switch (self.deviceType) {
        case 'ird_driver':
        case 'rtm_rc':
        case 'rtm_lc':
        case 'rtm_zsc':
        case 'rtm_zsc_v1':
        case 'rtm_dali_x':
        case 'rtm_dali_4':
        case 'rtm_dali_10':
        case 'rtm_dali_18':
        case 'rtm_zsc_100':
        case 'rtm_zsc_100E':
        case 'rtm_zsc_120':
        case 'rtm_zsc_f':
        case 'rtm_zsc_r':
        case 'rtm_zsc_s':
        case '9w_driver':
        case '21w_driver':
        case '9w_driver_dc':
        case '21w_driver_dc':
          types = ['dali']
          break
        case 'rtm_zsc_rgbw':
        case 'rtm_zsc_140':
        case 'rtm_zsc_130':
          types = ['color_rgbw']
          break;
        case 'rgb_driver':
          types = ['color']
          break
        case 'ird_rgb_driver':
          types = ['dali', 'color']
          break
        case 'rtm_io':
          types = ['gpio']
          break
      }

      console.log('aiai')
        console.log(self.deviceDefinition)
      // to support older device we check which device should have the 'older' day routine
      // older device also use a different time offset, this is handled by the 'legacyTimeOffset'
      let shouldHaveDayRoutine = self.deviceDefinition.routineType === 'day';
      let shouldHaveLegacyDeviceOffset = self.deviceDefinition.legacyTimeOffset
      self.routineComposers = []

      // generate the amount of composers needed to configure the device
      for (var i = 0; i < types.length; i++) {
        var type = types[i]

        var routinesList = routineByType[type]

        var regions = []
        // get all regions of the type
        for (var region in view.regions) {
          if (view.regions.hasOwnProperty(region)) {
            if (region.indexOf('routineRegion_' + type) > -1) {
              regions.push(region);
            }
          }
        }

        // walk through all the regions of this type and generate a composer
        regions.forEach((regionKey, index) => {
          var region = view.getRegion(regionKey);
          var routines = [];

          // check if there are set routines for this composer
          if (routinesList && Array.isArray(routinesList[index])) {
            routines = routinesList[index]
          }


          if (region) {
            var composer = new RoutineComposer({
              region: region,
              type: type,
              legacyTimeOffset: shouldHaveLegacyDeviceOffset,
              dayRoutine: shouldHaveDayRoutine,
              deviceType: self.deviceType,
              routine: routines,
              channel: index // defines the nth composer
            })

            self.listenTo(composer, 'control:send-command', self.onSendCommand)

            self.routineComposers.push(composer)
          }
        });



      }

    },
    /* Event methods --------------------------------------------------------- */
    onLoadPreset: function (view, presetId) {
      var self = this
      if (!view.options.client.get('presets')) return false

      var preset = _.find(view.options.client.get('presets'), function (o) { return o._id === presetId })
      self.routineRegion(view, preset.settings)
    },
    onSavePreset: function (view, presetOptions) {
      var self = this

      var client = view.options.client
      var routines = this.parseRoutines()
      App.dialog.prompt({
        message: App.TextParser('PROMPT_PRESET_NAME'),
        placeholder: '',
        callback: function (value) {
          if (!value) return false

          var preset = {
            'name': value,
            'type': 'control',
            'deviceType': self.deviceType,
            'settings': routines
          }

          client.addPreset(preset, {
            success: function () {
              view.render()
              App.dialog.notice(App.TextParser('NOTICE_PRESET_SAVED'))
            },
            error: function () {
              App.dialog.alert(App.TextParser('NOTICE_SAVE_FAILED'))
            }
          })
        }
      })
    },
    onSendCommand: function (data) {
      console.log('on send command')
      console.log(data)
      var self = this

      if (self.options.bulkAction) {
        let bulkCollection = self.view.collection
        return bulkCollection.sendBulkCommand(data)
      }

      if (self.options.group) {
        let group = self.options.group
        return group.sendCommand(data)
      }

      let device = self.device
      device.sendCommand(data, {
        success:(value) => {
          App.dialog.notice(App.TextParser('NOTICE_COMMAND_SENT'))
        }
      })
    },

    /* Views ----------------------------------------------------------------- */
    getBodyView: function (device, devices, client, deviceType) {
      var view
      var self = this
      if (!deviceType) console.warn('no devicetype give')

      switch (deviceType) {
        case 'ird_rgb_driver':
          view = View.BodyIrdRgbDriver
          break
        case 'ird_driver':
        case 'rtm_rc':
        case 'rtm_lc':
        case 'rtm_zsc_v1':
        // case 'rtm_dali_x':
        case 'rtm_dali_4':
        case 'rtm_dali_18':
        case 'rtm_zsc_100':
        case 'rtm_zsc_100E':
        case 'rtm_zsc_120':
        case 'rtm_zsc_f':
        case 'rtm_zsc_r':
        case 'rtm_zsc_s':
        case 'rtm_zsc':
          view = View.BodyIrdDriver
          break
        case 'rtm_dali_10':
        case 'rtm_dali_x':
          view = View.BodyDaliXDriver
          break;
        case 'rtm_zsc_rgbw':
        case 'rtm_zsc_140':
        case 'rtm_zsc_130':
          view = View.BodyZscRgbwDriver
          break
        case '9w_driver':
        case '21w_driver':
        case '9w_driver_dc':
        case '21w_driver_dc':
          view = View.BodyXwDriver
          break
        case 'rgb_driver':
          view = View.BodyRgbDriver
          break
        case 'rtm_io':
          view = View.BodyRtmIoDriver
          break
        default:
          view = View.Body
          break
      }

      return new view({
        model: device,
        collection: devices,
        client: client,
        deviceType: deviceType,
        controlButtons: self.controlButtons[deviceType]
      })
    },
    getWrapperView: function(deviceType) {
      return new View.Wrapper({deviceType: deviceType})
    },
    getView: function (dialogModel, device, devices, client, deviceType) {
      return new View.Layout({
        dialogModel: dialogModel,
        model: device,
        collection: devices,
        client: client,
        deviceType: deviceType
      })
    }

  })

  return new Controller(options)
}

module.exports = DeviceControl



// WEBPACK FOOTER //
// ./js/modules/devices/control/index.js